export class PermissionGroupModel {
    name: string;
    permissions: PermissionModel[];
    isChecked?: boolean;
}

export class PermissionModel {
    name: string;
    value: number;
    isChecked?: boolean;
}
export enum RoleType {
    UserRole = 0,
    Benefit = 1,
}

export const ROLE_TYPE_OPTIONS = [
    { value: RoleType.UserRole, label: 'Vai trò', emptyLabel: 'customer_roles_empty' },
    { value: RoleType.Benefit, label: 'Ưu đãi', emptyLabel: 'customer_benefits_empty' },
];

export interface RoleUpdateResponse {
    statusCode: number;
    message?: string;
}

export class RoleModel {
    id?: string;
    roleName: string;
    roleType?: RoleType;
    createdDate?: string;
    createdBy?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    isActive: boolean;
    permissions: number[];
    priority?: number;
}

export enum PermissionAction {

    //#region User
    CreateUser = 1001,
    UpdateUser = 1002,
    DeleteUser = 1003,
    ViewUser = 1004,
    ViewAllUser = 1005,
    UpdateAllUser = 1006,
    ExportUser = 1010,
    UpdateStatusUser = 1008,
    UpdateUserBusinessScope = 1009,
    ConfirmVatUser = 1011,
    UpdateUserBusinessProfile = 1112,
    ConfirmBusinessProfileUser = 1113,
    UpdateUserRole = 1114,
    UpdateUserDeliveryAddress = 1115,
    ConfirmUserDeliveryAddress = 1116,
    CreateUserDeliveryAddress = 1117,
    DeleteUserDeliveryAddress = 1118,
    PushErpAllUsers = 1119,
    ConfirmSkipAutoUpdateBusinessName = 1120,
    CreateUserPurchasedProducts = 1121,
    ImportCsStaff = 1122,
    //#endregion

    //#region Product
    CreateProduct = 2001,
    UpdateProduct = 2002,
    DeleteProduct = 2003,
    ViewProduct = 2004,
    ViewAllProduct = 2005,
    ExportProduct = 2006,
    //#endregion

    //#region Category
    CreateCategory = 3001,
    UpdateCategory = 3002,
    DeleteCategory = 3003,
    ViewCategory = 3004,
    ViewAllCategory = 3005,
    //#endregion

    //#region Voucher
    CreateVoucher = 26001,
    //#endregion

    //#region Role
    CreateRole = 4001,
    UpdateRole = 4002,
    DeleteRole = 4003,
    ViewRole = 4004,
    ViewAllRole = 4005,
    ViewPermission = 4010,
    //#endregion

    //#region Order
    CreateOrder = 5001,
    UpdateOrder = 5002,
    DeleteOrder = 5003,
    ViewOrder = 5004,
    ViewAllOrder = 5005,
    VoucherApplyPostOrder = 5006,
    VoucherCompensatePostOrder = 5007,
    ImportOrder = 5009,
    UpdateStatusOrder = 5010,
    RemoveOrderGift = 5011,
    UpdateOrderItemPrice = 5012,
    ExportOrderFulfillment = 5021,
    ExportNewOrderFulfillment = 5022,
    ExportOrderFulfillmentDetail = 5023,
    ExportOrderFulfillmentSummary = 5024,
    GetProductOrderShipment = 5025,
    PushErpAllOrders = 5026,
    AddOrderItem = 5027,
    CreatePurchaseRequest = 5028,
    UpdatePurchaseRequest = 5029,
    ViewPurchaseRequest = 5030,
    PushPurchaseRequestToErp = 5031,
    UpdateOrderRegion = 5032,
    SplitOrder = 5033,
    // 29/10/2026 (WP3699): xuất Excel yêu cầu trả hàng theo bộ lọc đang chọn. Mã chờ backend xác nhận
    // trong Permission.cs và cấp cho role CS.
    ExportReturnOrder = 20006,

    //#endregion

    //#region Cart
    CreateCart = 6001,
    UpdateCart = 6002,
    DeleteCart = 6003,
    ViewCart = 6004,
    ViewAllCart = 6005,
    //#endregion

    //#region Article
    CreatePostCategory = 7001,
    UpdatePostCategory = 7002,
    DeletePostCategory = 7003,
    ViewPostCategory = 7004,

    CreatePost = 7011,
    UpdatePost = 7012,
    DeletePost = 7013,
    ViewPost = 7014,

    CreateBlogConfig = 7021,
    UpdateBlogConfig = 7022,
    DeleteBlogConfig = 7023,
    ViewBlogConfig = 7024,
    //#endregion

    //#region Tag

    CreateTag = 9001,
    UpdateTag = 9002,
    DeleteTag = 9003,
    ViewTag = 9004,

    //#endregion

    //#region Configuration
    CreateConfiguration = 8001,
    UpdateConfiguration = 8002,
    DeleteConfiguration = 8003,
    ViewConfiguration = 8004,
    ViewAllConfiguration = 8005,
    //#endregion

    //#region Job
    DeleteJob = 12003,
    //#endregion

    //region Notification
    CreateTopic = 14001,
    UpdateTopic = 14002,
    DeleteTopic = 14003,
    ViewTopic = 14004,

    CreateNotification = 15001,

    //endregion

    //#region Configuration v2
    CreateConfigurationV2 = 18001,
    UpdateConfigurationV2 = 18002,
    ViewConfigurationV2 = 18003,
    ViewPromotionPageConfiguration = 18004,
    //#endregion

    //#region Coin, Order Coin, Wallet
    ViewWalletCoin = 21004,
    AdjustWalletCoin = 21005,
    ReportOrderWalletCoin = 21006,
    ViewAllWallet = 21007,
    //#endregion

    //#region Employee
    ViewEmployee = 22004,
    //#endregion

    //#region Mision
    CreateAchievement = 25001,
    UpdateAchievement = 25002,
    DeleteAchievement = 25003,
    //#endregion

    // 30/09/2026: chính sách phân quyền report (xem comment đầy đủ ở Permission.cs backend) - mỗi domain chỉ
    // 1 quyền "chính" gate mọi trang con; CHỈ report/finance/ar-ap (ViewReportFinanceReceivables) và
    // report/bod/profit (ViewReportBodProfit) cần quyền chi tiết hơn. Các quyền "phụ" khác dưới đây không còn
    // dùng ở route nào - giữ enum vì DB phân quyền cũ có thể còn tham chiếu.

    //#region Report - Kho vận
    ViewReportWarehouse = 32001,
    ViewReportWarehouseOutboundOps = 32002,
    ViewReportWarehouseComplaints = 32003,
    ViewReportWarehouseLogistics = 32004,
    ViewReportWarehouseSupplyCost = 32005,
    ViewReportWarehouseInventory = 32006,
    //#endregion

    //#region Report - BoD
    ViewReportBod = 33001,
    ViewReportBodProfit = 33002,
    ViewReportBodCustomerRisk = 33003,
    ViewReportBodSales = 33004,
    ViewReportBodInventory = 33005,
    //#endregion

    //#region Report - Mua hàng
    ViewReportPurchasing = 34001,
    ViewReportPurchasingLeadtime = 34002,
    ViewReportPurchasingOtif = 34004,
    ViewReportPurchasingFfm = 34005,
    ViewReportPurchasingInventory = 34006,
    ViewReportPurchasingRebate = 34007,
    //#endregion

    //#region Report - Kinh doanh
    ViewReportSales = 35001,
    ViewReportSalesComplaints = 35002,
    //#endregion

    //#region Report - Tài chính
    ViewReportFinance = 36001,
    ViewReportFinanceReceivables = 36002,
    // 30/09/2026: gộp vào ViewReportFinanceReceivables, không còn dùng riêng ở route/permission check nào - xem
    // comment ở Permission.cs (backend).
    ViewReportFinancePayables = 36003,
    //#endregion

    //#region Report - Ecom
    ViewReportEcom = 37001,
    ViewReportEcomOrders = 37002,
    ViewReportEcomBasket = 37003,
    ViewReportEcomCart = 37004,
    ViewReportEcomCustomerRecency = 37005,
    ViewReportEcomCustomerRepurchase = 37006,
    //#endregion

    //#region Report - Kiểm soát nội bộ
    // 15/10/2026: xem hành vi nhân viên trên admin. Quyền riêng, không dùng chung ViewReportEcom/ViewReportBod.
    ViewReportAdminAudit = 38001,
    //#endregion

    //#region Tìm kiếm sản phẩm
    // 20/10/2026: quản lý bảng map từ khóa và bảng sản phẩm thay thế của gợi ý tìm kiếm.
    ViewSearchRule = 39001,
    EditSearchRule = 39002,
    //#endregion

    //#region Budget CTKM
    // 24/10/2026 (WP 3498): View xem budget; Edit (Mua hàng) tạo/sửa budget, chia allocation, nhập phần đã dùng tay; Manage (CE Lead) phân bổ lại, đối soát, đóng budget.
    ViewPromotionBudget = 40001,
    EditPromotionBudget = 40002,
    ManagePromotionBudget = 40003,
    //#endregion
}

export function IsAuthurization(userPermissions: number[], requiredPermission: number | number[] | undefined): boolean {
    if (!Array.isArray(requiredPermission) && typeof requiredPermission !== 'undefined' && userPermissions.includes(requiredPermission) || !requiredPermission) {
        return true;
    } else if (Array.isArray(requiredPermission) && requiredPermission?.length &&
        requiredPermission.every(action => userPermissions?.includes(action))) {
        return true;
    } else {
        return false
    }
}

export class RolePagingModel {
    data: RoleModel[];
    total: number;
}

